import Vue from 'vue'
import Vuex from 'vuex'
import commonService from '~/services/common.service'

Vue.use(Vuex)

Vue.config.devtools = true

// Auto Import all of the resource store files.
const context = require.context('.', true, /.store.js/)
const modules = {}

context.keys().forEach((file) => {

  // create the module name from file
  const moduleName = file.replace(/(\.\/|\.store\.js$)/g, '')

  // register file context under module name
  modules[moduleName] = context(file).default || context(file)

  // override namespaced option
  modules[moduleName].namespaced = true
})

export default new Vuex.Store({
  state: {
    simBranchList: [],
    provinceList: [],
    elevatorBranchList: [],
    userProfile: null,
    stepByStep: {
      current: null,
    },
  },
  mutations: {
    setData(state, payload) {
      Object.keys(payload).forEach(key => {
        if (state[key] !== undefined) {
          state[key] = payload[key]
        }
      })
    },
    setStepGuide(state, payload) {
      state.stepByStep.current = payload
    }
  },
  actions: {
    async initMasterData({ commit }) {
      const {
        provinceList,
        simBranchList,
        elevatorBranchList,
      } = await commonService.getMasterData()
      commit('setData', {
        provinceList,
        simBranchList,
        elevatorBranchList,
      })
    },
    async getUserProfile({ commit }) {
      const data = await commonService.getUserProfile()
      commit('setData', { userProfile: data })
    },
  },
  getters: {
    simBranchList(state) {
      return state.simBranchList
    },
    elevatorBranchList(state) {
      return state.elevatorBranchList
    },
    provinceList(state) {
      return state.provinceList
    },
    isGuideForUser(state) {
      return typeof state.stepByStep.current === "number"
    }
  },
  modules
})
